import { cn } from "@roman/shared/utils";

export const MustReadTitle = ({
  title,
  titleFontSize = "16px",
  labelFontSize = "14px",
}: {
  title: string;
  titleFontSize?: string;
  labelFontSize?: string;
}) => {
  return (
    <div className="flex items-center border-b-2 border-secondary">
      <div className="bg-secondary px-3 py-1 rounded-tl-md rounded-tr-md">
        <p className={cn("text-white font-bold", `text-[${labelFontSize}]`)}>必読</p>
      </div>
      <div className="ml-4">
        <p className={cn("text-black font-bold", `text-[${titleFontSize}]`)}>{title}</p>
      </div>
    </div>
  );
};
